import { createApp } from 'vue'
import App from '@/index/App.vue'
import '@/main.css'

createApp(App).mount('#app')
